

// v1 without Cash
// import React, { useEffect, useRef } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
//   FormControl,
//   InputLabel,
//   Select,
// } from "@mui/material";
// import { Formik, Form, FieldArray, useFormikContext } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";

// const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

// const returnedValidationSchema = (t) =>
//   Yup.object({
//     returneds: Yup.array()
//       .of(
//         Yup.object({
//           returned_account_no: Yup.string().required(t("returneds.validation.accountNoRequired")),
//           returned_ifsc_code: Yup.string().required(t("returneds.validation.ifscCodeRequired")),
//           returned_bank_name: Yup.string().required(t("returneds.validation.bankNameRequired")),
//           returned_branch_name: Yup.string().required(t("returneds.validation.branchNameRequired")),
//           returned_mode_of_payment: Yup.string().required(t("returneds.validation.modeRequired")),
//           returned_scheme: Yup.string().required(t("returneds.validation.schemeRequired")),
//           returned_amt: Yup.number()
//             .typeError(t("returneds.validation.amountNumber"))
//             .required(t("returneds.validation.amountRequired")),
//           returned_proof: Yup.mixed()
//             .required(t("returneds.validation.proofRequired"))
//             .test(
//               "fileExists",
//               t("returneds.validation.proofRequired"),
//               (value) => value && typeof value.name === "string" && value.name.length > 0
//             )
//             .test(
//               "fileSize",
//               t("baseInfo.validation.fileSizeExceeded") || "File size must be less than 2MB",
//               (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
//             ),
//         })
//       )
//       .min(1, t("returneds.validation.atLeastOne")),
//   });

// const TotalWatcher = ({ onTotalChange }) => {
//   const { values } = useFormikContext();
//   useEffect(() => {
//     if (values.returneds) {
//       const total = values.returneds.reduce((sum, ret) => sum + (Number(ret.returned_amt) || 0), 0);
//       if (onTotalChange) onTotalChange(total);
//     }
//   }, [values.returneds, onTotalChange]);
//   return null;
// };

// const ReturnedSection = ({
//   returneds,
//   setReturneds,
//   activeTab,
//   setActiveTab,
//   onTotalChange,
//   schemeOptions,
//   investments,
// }) => {
//   const { t, i18n } = useTranslation();
//   const validationSchema = React.useMemo(() => returnedValidationSchema(t), [i18n.language]);

//   const formikHelpers = useRef(null);
//   useEffect(() => {
//     if (!formikHelpers.current) return;
//     const { errors, touched, setFieldTouched } = formikHelpers.current;
//     const handleLangChange = () => {
//       Object.keys(errors).forEach((field) => {
//         if (touched[field]) setFieldTouched(field);
//       });
//     };
//     i18n.on("languageChanged", handleLangChange);
//     return () => i18n.off("languageChanged", handleLangChange);
//   }, [i18n]);

//   const handleAccountChange = (formikHelpers, index, acc_no) => {
//     const investment = investments.find((inv) => inv.inv_account_no === acc_no);
//     if (investment) {
//       formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, investment.inv_account_no);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, investment.inv_bank_name);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, investment.inv_ifsc_code);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, investment.inv_branch_name);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, investment.inv_scheme);
//     } else {
//       formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, "");
//     }
//   };

//   return (
//     <Formik
//       initialValues={{ returneds }}
//       validationSchema={validationSchema}
//       enableReinitialize
//       onSubmit={(values) => {
//         setReturneds(values.returneds);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {(formik) => {
//         formikHelpers.current = formik;

//         const {
//           values,
//           errors,
//           touched,
//           handleChange,
//           handleBlur,
//           setFieldValue,
//           setFieldTouched,
//         } = formik;
//         const totalReturned = values.returneds.reduce(
//           (sum, ret) => sum + (Number(ret.returned_amt) || 0),
//           0
//         );
//         const selectFormControlSX = { minWidth: 200, maxWidth: "100%" };

//         return (
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Form noValidate>
//                 <Stack spacing={3}>
//                   <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
//                     {t("returneds.heading")}
//                   </Typography>

//                   <TotalWatcher onTotalChange={onTotalChange} />

//                   <FieldArray name="returneds">
//                     {({ remove, push }) => (
//                       <>
//                         {values.returneds.map((ret, i) => {
//                           const touchedRet = touched.returneds?.[i] || {};
//                           const errorsRet = errors.returneds?.[i] || {};

//                           return (
//                             <Box key={i} mb={2} p={2} sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
//                               <TwoFieldRow>
//                                 <FormControl fullWidth sx={selectFormControlSX} error={touchedRet.returned_account_no && Boolean(errorsRet.returned_account_no)}>
//                                   <InputLabel>{t("returneds.returnedAccountNo")}</InputLabel>
//                                   <Select
//                                     name={`returneds[${i}].returned_account_no`}
//                                     value={ret.returned_account_no || ""}
//                                     label={t("returneds.returnedAccountNo")}
//                                     onChange={(e) => handleAccountChange(formikHelpers.current, i, e.target.value)}
//                                     onBlur={handleBlur}
//                                   >
//                                     <MenuItem value="">
//                                       <em>{t("common.select")}</em>
//                                     </MenuItem>
//                                     {investments.map((inv) => (
//                                       <MenuItem key={inv.inv_account_no} value={inv.inv_account_no}>
//                                         {`${inv.inv_account_no} - ${inv.inv_scheme}`}
//                                       </MenuItem>
//                                     ))}
//                                   </Select>
//                                   {touchedRet.returned_account_no && errorsRet.returned_account_no && (
//                                     <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                       {errorsRet.returned_account_no}
//                                     </Typography>
//                                   )}
//                                 </FormControl>

//                                 <TextField
//                                   label={t("returneds.bankName")}
//                                   name={`returneds[${i}].returned_bank_name`}
//                                   value={ret.returned_bank_name}
//                                   InputProps={{ readOnly: true }}
//                                   fullWidth
//                                   sx={{ ml: 2 }}
//                                 />
//                               </TwoFieldRow>

//                               <TwoFieldRow>
//                                 <TextField
//                                   label={t("returneds.ifscCode")}
//                                   name={`returneds[${i}].returned_ifsc_code`}
//                                   value={ret.returned_ifsc_code}
//                                   InputProps={{ readOnly: true }}
//                                   fullWidth
//                                   error={touchedRet.returned_ifsc_code && Boolean(errorsRet.returned_ifsc_code)}
//                                   helperText={touchedRet.returned_ifsc_code && errorsRet.returned_ifsc_code}
//                                 />
//                                 <TextField
//                                   label={t("returneds.branchName")}
//                                   name={`returneds[${i}].returned_branch_name`}
//                                   value={ret.returned_branch_name}
//                                   InputProps={{ readOnly: true }}
//                                   fullWidth
//                                   error={touchedRet.returned_branch_name && Boolean(errorsRet.returned_branch_name)}
//                                   helperText={touchedRet.returned_branch_name && errorsRet.returned_branch_name}
//                                 />
//                               </TwoFieldRow>

//                               {/* Scheme as read-only TextField */}
//                               <TextField
//                                 label={t("returneds.scheme")}
//                                 name={`returneds[${i}].returned_scheme`}
//                                 value={ret.returned_scheme || ""}
//                                 InputProps={{ readOnly: true }}
//                                 fullWidth
//                                 error={touchedRet.returned_scheme && Boolean(errorsRet.returned_scheme)}
//                                 helperText={touchedRet.returned_scheme && errorsRet.returned_scheme}
//                                 sx={{ mb: 2 }}
//                               />

//                               <TwoFieldRow>
//                                 <FormControl fullWidth sx={selectFormControlSX} error={touchedRet.returned_mode_of_payment && Boolean(errorsRet.returned_mode_of_payment)}>
//                                   <InputLabel>{t("returneds.modeOfPayment")}</InputLabel>
//                                   <Select
//                                     name={`returneds[${i}].returned_mode_of_payment`}
//                                     value={ret.returned_mode_of_payment}
//                                     label={t("returneds.modeOfPayment")}
//                                     onChange={handleChange}
//                                     onBlur={handleBlur}
//                                   >
//                                     <MenuItem value="">{t("returneds.selectMode")}</MenuItem>
//                                     <MenuItem value="NEFT">NEFT</MenuItem>
//                                     <MenuItem value="Cash">Cash</MenuItem>
//                                     <MenuItem value="Cheque">Cheque</MenuItem>
//                                     <MenuItem value="RTGS">RTGS</MenuItem>
//                                     <MenuItem value="UPI">UPI</MenuItem>
//                                   </Select>
//                                   {touchedRet.returned_mode_of_payment && errorsRet.returned_mode_of_payment && (
//                                     <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                       {errorsRet.returned_mode_of_payment}
//                                     </Typography>
//                                   )}
//                                 </FormControl>

//                                 <TextField
//                                   label={t("returneds.amount")}
//                                   name={`returneds[${i}].returned_amt`}
//                                   value={ret.returned_amt}
//                                   onChange={handleChange}
//                                   onBlur={handleBlur}
//                                   fullWidth
//                                   error={touchedRet.returned_amt && Boolean(errorsRet.returned_amt)}
//                                   helperText={touchedRet.returned_amt && errorsRet.returned_amt}
//                                 />
//                               </TwoFieldRow>

//                               <Box sx={{ mb: 1 }}>
//                                 <UploadWithLabel
//                                   label={`${t("returneds.uploadStatement")}`}
//                                   name={`returneds[${i}].returned_proof`}
//                                   onChange={(e) => {
//                                     setFieldValue(`returneds[${i}].returned_proof`, e.currentTarget.files[0]);
//                                     setFieldTouched(`returneds[${i}].returned_proof`, true);
//                                   }}
//                                   file={ret.returned_proof}
//                                   error={touchedRet.returned_proof && Boolean(errorsRet.returned_proof)}
//                                   helperText={touchedRet.returned_proof && errorsRet.returned_proof}
//                                 />
//                               </Box>

//                               <Button
//                                 variant="outlined"
//                                 color="error"
//                                 onClick={() => values.returneds.length > 1 && setFieldValue("returneds", values.returneds.filter((_, idx) => idx !== i))}
//                                 sx={{ mt: 1 }}
//                               >
//                                 {t("common.remove")}
//                               </Button>
//                             </Box>
//                           );
//                         })}

//                         <Button
//                           variant="contained"
//                           sx={{ mt: 2 }}
//                           onClick={() =>
//                             setFieldValue("returneds", [
//                               ...values.returneds,
//                               {
//                                 returned_account_no: "",
//                                 returned_ifsc_code: "",
//                                 returned_bank_name: "",
//                                 returned_branch_name: "",
//                                 returned_mode_of_payment: "",
//                                 returned_scheme: "",
//                                 returned_amt: "",
//                                 returned_proof: null,
//                               },
//                             ])
//                           }
//                         >
//                           {t("returneds.addReturned")}
//                         </Button>

//                         <Box sx={{ mt: 4, p: 2, border: "1px solid #999", borderRadius: 2, backgroundColor: "#f9f9f9" }}>
//                           <Typography variant="h6" gutterBottom>
//                             {t("returneds.summary")}
//                           </Typography>
//                           <TextField
//                             label={t("returneds.totalReturnedAmount")}
//                             value={totalReturned.toFixed(2)}
//                             InputProps={{ readOnly: true }}
//                             fullWidth
//                           />
//                         </Box>

//                         <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//                           <Button variant="outlined" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
//                             {t("common.back")}
//                           </Button>
//                           <Box sx={{ display: "flex", gap: 2 }}>
//                             <Button variant="outlined" color="secondary" onClick={() => setActiveTab(activeTab + 1)}>
//                               {t("common.skip")}
//                             </Button>
//                             <Button type="submit" variant="contained">
//                               {t("common.next")}
//                             </Button>
//                           </Box>
//                         </Box>
//                       </>
//                     )}
//                   </FieldArray>
//                 </Stack>
//               </Form>
//             </Paper>
//           </Container>
//         );
//       }}
//     </Formik>
//   );
// };

// export default ReturnedSection;



// v2 with Cash
// import React, { useEffect, useRef } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
//   FormControl,
//   InputLabel,
//   Select,
// } from "@mui/material";
// import { Formik, Form, FieldArray, useFormikContext } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";

// const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

// const returnedValidationSchema = (t) =>
//   Yup.object({
//     returneds: Yup.array()
//       .of(
//         Yup.object({
//           returned_account_no: Yup.string()
//             .test(
//               "account-no-required",
//               t("returneds.validation.accountNoRequired"),
//               function (value) {
//                 // Get the current returned data to check if it's CASH
//                 const { returned_bank_name } = this.parent;
//                 // If returned_bank_name is "CASH", then returned_account_no is not required
//                 if (returned_bank_name === "CASH") {
//                   return true; // Validation passes for CASH
//                 }
//                 // Otherwise, returned_account_no is required
//                 return !!value && value.trim() !== "";
//               }
//             ),
//           returned_ifsc_code: Yup.string().required(t("returneds.validation.ifscCodeRequired")),
//           returned_bank_name: Yup.string().required(t("returneds.validation.bankNameRequired")),
//           returned_branch_name: Yup.string().required(t("returneds.validation.branchNameRequired")),
//           returned_mode_of_payment: Yup.string().required(t("returneds.validation.modeRequired")),
//           returned_scheme: Yup.string().required(t("returneds.validation.schemeRequired")),
//           returned_amt: Yup.number()
//             .typeError(t("returneds.validation.amountNumber"))
//             .required(t("returneds.validation.amountRequired")),
//           returned_proof: Yup.mixed()
//             .required(t("returneds.validation.proofRequired"))
//             .test(
//               "fileType",
//               t("returneds.validation.fileMustBePDF"),
//               (value) => !value || (value && value.type === "application/pdf")
//             )
//             .test(
//               "fileSize",
//               t("baseInfo.validation.fileSizeExceeded") || "File size must be less than 2MB",
//               (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
//             ),
//         })
//       )
//       .min(1, t("returneds.validation.atLeastOne")),
//   });

// const TotalWatcher = ({ onTotalChange }) => {
//   const { values } = useFormikContext();
//   useEffect(() => {
//     if (values.returneds) {
//       const total = values.returneds.reduce((sum, ret) => sum + (Number(ret.returned_amt) || 0), 0);
//       if (onTotalChange) onTotalChange(total);
//     }
//   }, [values.returneds, onTotalChange]);
//   return null;
// };

// const ReturnedSection = ({
//   returneds,
//   setReturneds,
//   activeTab,
//   setActiveTab,
//   onTotalChange,
//   schemeOptions,
//   investments,
// }) => {
//   const { t, i18n } = useTranslation();
//   const validationSchema = React.useMemo(() => returnedValidationSchema(t), [i18n.language]);

//   const formikHelpers = useRef(null);
//   useEffect(() => {
//     if (!formikHelpers.current) return;
//     const { errors, touched, setFieldTouched } = formikHelpers.current;
//     const handleLangChange = () => {
//       Object.keys(errors).forEach((field) => {
//         if (touched[field]) setFieldTouched(field);
//       });
//     };
//     i18n.on("languageChanged", handleLangChange);
//     return () => i18n.off("languageChanged", handleLangChange);
//   }, [i18n]);

//   const handleAccountChange = (formikHelpers, index, acc_no) => {
//     // Check if this is a CASH option (starts with "CASH_")
//     if (acc_no && acc_no.startsWith("CASH_")) {
//       // Extract scheme from CASH option (format: "CASH_FD")
//       const scheme = acc_no.replace("CASH_", "");
//       // Set empty account number for CASH transactions
//       formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, "CASH");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, "CASH");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, "CASH");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, scheme);
//       return;
//     }

//     // Regular investment account
//     const investment = investments.find((inv) => inv.inv_account_no === acc_no);
//     if (investment) {
//       formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, investment.inv_account_no);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, investment.inv_bank_name);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, investment.inv_ifsc_code);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, investment.inv_branch_name);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, investment.inv_scheme);
//     } else {
//       formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, "");
//     }
//   };

//   // Prepare investment options for the dropdown
//   const getInvestmentOptions = () => {
//     const options = [];
//     const schemeWithAccount = new Set(); // Track schemes that have account numbers
    
//     // First, add all investment accounts with their schemes
//     investments.forEach((inv) => {
//       if (inv.inv_account_no && inv.inv_scheme) {
//         const scheme = inv.inv_scheme;
//         const displayLabel = `${inv.inv_account_no} - ${scheme}`;
//         options.push({
//           value: inv.inv_account_no,
//           label: displayLabel,
//           scheme: scheme,
//           hasAccount: true
//         });
//         // Mark this scheme as having an account
//         schemeWithAccount.add(scheme);
//       }
//     });
    
//     // Add CASH options only for schemes that don't already have an account
//     schemeOptions.forEach((scheme) => {
//       if (scheme && !schemeWithAccount.has(scheme)) {
//         options.push({
//           value: `CASH_${scheme}`,
//           label: `- ${scheme}`,
//           scheme: scheme,
//           hasAccount: false
//         });
//       }
//     });
    
//     return options;
//   };

//   const investmentOptions = getInvestmentOptions();

//   return (
//     <Formik
//       initialValues={{ returneds }}
//       validationSchema={validationSchema}
//       enableReinitialize
//       onSubmit={(values) => {
//         setReturneds(values.returneds);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {(formik) => {
//         formikHelpers.current = formik;

//         const {
//           values,
//           errors,
//           touched,
//           handleChange,
//           handleBlur,
//           setFieldValue,
//           setFieldTouched,
//         } = formik;
//         const totalReturned = values.returneds.reduce(
//           (sum, ret) => sum + (Number(ret.returned_amt) || 0),
//           0
//         );
//         const selectFormControlSX = { minWidth: 200, maxWidth: "100%" };

//         return (
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Form noValidate>
//                 <Stack spacing={3}>
//                   <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
//                     {t("returneds.heading")}
//                   </Typography>

//                   <TotalWatcher onTotalChange={onTotalChange} />

//                   <FieldArray name="returneds">
//                     {({ remove, push }) => (
//                       <>
//                         {values.returneds.map((ret, i) => {
//                           const touchedRet = touched.returneds?.[i] || {};
//                           const errorsRet = errors.returneds?.[i] || {};

//                           // Check if current selection is CASH
//                           const isCash = ret.returned_bank_name === "CASH" || 
//                                          ret.returned_ifsc_code === "CASH" || 
//                                          ret.returned_branch_name === "CASH";

//                           return (
//                             <Box key={i} mb={2} p={2} sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
//                               <TwoFieldRow>
//                                 <FormControl fullWidth sx={selectFormControlSX} error={touchedRet.returned_account_no && Boolean(errorsRet.returned_account_no)}>
//                                   <InputLabel>{t("returneds.returnedAccountNo")}</InputLabel>
//                                   <Select
//                                     name={`returneds[${i}].returned_account_no`}
//                                     value={ret.returned_account_no || ""}
//                                     label={t("returneds.returnedAccountNo")}
//                                     onChange={(e) => {
//                                       const value = e.target.value;
//                                       setFieldValue(`returneds[${i}].returned_account_no`, value);
//                                       handleAccountChange(formikHelpers.current, i, value);
//                                     }}
//                                     onBlur={handleBlur}
//                                   >
//                                     <MenuItem value="">
//                                       <em>{t("common.select")}</em>
//                                     </MenuItem>
//                                     {investmentOptions.map((option) => (
//                                       <MenuItem key={option.value} value={option.value}>
//                                         {option.label}
//                                       </MenuItem>
//                                     ))}
//                                   </Select>
//                                   {touchedRet.returned_account_no && errorsRet.returned_account_no && (
//                                     <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                       {errorsRet.returned_account_no}
//                                     </Typography>
//                                   )}
//                                 </FormControl>

//                                 <TextField
//                                   label={t("returneds.bankName")}
//                                   name={`returneds[${i}].returned_bank_name`}
//                                   value={ret.returned_bank_name}
//                                   InputProps={{ readOnly: true }}
//                                   fullWidth
//                                   sx={{ ml: 2 }}
//                                 />
//                               </TwoFieldRow>

//                               <TwoFieldRow>
//                                 <TextField
//                                   label={t("returneds.ifscCode")}
//                                   name={`returneds[${i}].returned_ifsc_code`}
//                                   value={ret.returned_ifsc_code}
//                                   InputProps={{ readOnly: true }}
//                                   fullWidth
//                                   error={touchedRet.returned_ifsc_code && Boolean(errorsRet.returned_ifsc_code)}
//                                   helperText={touchedRet.returned_ifsc_code && errorsRet.returned_ifsc_code}
//                                 />
//                                 <TextField
//                                   label={t("returneds.branchName")}
//                                   name={`returneds[${i}].returned_branch_name`}
//                                   value={ret.returned_branch_name}
//                                   InputProps={{ readOnly: true }}
//                                   fullWidth
//                                   error={touchedRet.returned_branch_name && Boolean(errorsRet.returned_branch_name)}
//                                   helperText={touchedRet.returned_branch_name && errorsRet.returned_branch_name}
//                                 />
//                               </TwoFieldRow>

//                               {/* Scheme as read-only TextField */}
//                               <TextField
//                                 label={t("returneds.scheme")}
//                                 name={`returneds[${i}].returned_scheme`}
//                                 value={ret.returned_scheme || ""}
//                                 InputProps={{ readOnly: true }}
//                                 fullWidth
//                                 error={touchedRet.returned_scheme && Boolean(errorsRet.returned_scheme)}
//                                 helperText={touchedRet.returned_scheme && errorsRet.returned_scheme}
//                                 sx={{ mb: 2 }}
//                               />

//                               <TwoFieldRow>
//                                 <FormControl fullWidth sx={selectFormControlSX} error={touchedRet.returned_mode_of_payment && Boolean(errorsRet.returned_mode_of_payment)}>
//                                   <InputLabel>{t("returneds.modeOfPayment")}</InputLabel>
//                                   <Select
//                                     name={`returneds[${i}].returned_mode_of_payment`}
//                                     value={ret.returned_mode_of_payment}
//                                     label={t("returneds.modeOfPayment")}
//                                     onChange={handleChange}
//                                     onBlur={handleBlur}
//                                   >
//                                     <MenuItem value="">{t("returneds.selectMode")}</MenuItem>
//                                     <MenuItem value="NEFT">NEFT</MenuItem>
//                                     <MenuItem value="Cash">Cash</MenuItem>
//                                     <MenuItem value="Cheque">Cheque</MenuItem>
//                                     <MenuItem value="RTGS">RTGS</MenuItem>
//                                     <MenuItem value="UPI">UPI</MenuItem>
//                                   </Select>
//                                   {touchedRet.returned_mode_of_payment && errorsRet.returned_mode_of_payment && (
//                                     <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                       {errorsRet.returned_mode_of_payment}
//                                     </Typography>
//                                   )}
//                                 </FormControl>

//                                 <TextField
//                                   label={t("returneds.amount")}
//                                   name={`returneds[${i}].returned_amt`}
//                                   value={ret.returned_amt}
//                                   onChange={handleChange}
//                                   onBlur={handleBlur}
//                                   fullWidth
//                                   error={touchedRet.returned_amt && Boolean(errorsRet.returned_amt)}
//                                   helperText={touchedRet.returned_amt && errorsRet.returned_amt}
//                                 />
//                               </TwoFieldRow>

//                               <Box sx={{ mb: 1 }}>
//                                 <UploadWithLabel
//                                   label={`${t("returneds.uploadStatement")}`}
//                                   name={`returneds[${i}].returned_proof`}
//                                   onChange={(e) => {
//                                     const file = e.currentTarget.files[0];
//                                     if (file) {
//                                       setFieldValue(`returneds[${i}].returned_proof`, file);
//                                       setFieldTouched(`returneds[${i}].returned_proof`, true);
//                                     }
//                                   }}
//                                   accept=".pdf,application/pdf"
//                                   file={ret.returned_proof}
//                                   error={touchedRet.returned_proof && Boolean(errorsRet.returned_proof)}
//                                   helperText={touchedRet.returned_proof && errorsRet.returned_proof}
//                                 />
//                               </Box>

//                               <Button
//                                 variant="outlined"
//                                 color="error"
//                                 onClick={() => values.returneds.length > 1 && setFieldValue("returneds", values.returneds.filter((_, idx) => idx !== i))}
//                                 sx={{ mt: 1 }}
//                               >
//                                 {t("common.remove")}
//                               </Button>
//                             </Box>
//                           );
//                         })}

//                         <Button
//                           variant="contained"
//                           sx={{ mt: 2 }}
//                           onClick={() =>
//                             setFieldValue("returneds", [
//                               ...values.returneds,
//                               {
//                                 returned_account_no: "",
//                                 returned_ifsc_code: "",
//                                 returned_bank_name: "",
//                                 returned_branch_name: "",
//                                 returned_mode_of_payment: "",
//                                 returned_scheme: "",
//                                 returned_amt: "",
//                                 returned_proof: null,
//                               },
//                             ])
//                           }
//                         >
//                           {t("returneds.addReturned")}
//                         </Button>

//                         <Box sx={{ mt: 4, p: 2, border: "1px solid #999", borderRadius: 2, backgroundColor: "#f9f9f9" }}>
//                           <Typography variant="h6" gutterBottom>
//                             {t("returneds.summary")}
//                           </Typography>
//                           <TextField
//                             label={t("returneds.totalReturnedAmount")}
//                             value={totalReturned.toFixed(2)}
//                             InputProps={{ readOnly: true }}
//                             fullWidth
//                           />
//                         </Box>

//                         <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//                           <Button variant="outlined" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
//                             {t("common.back")}
//                           </Button>
//                           <Box sx={{ display: "flex", gap: 2 }}>
//                             <Button variant="outlined" color="secondary" onClick={() => setActiveTab(activeTab + 1)}>
//                               {t("common.skip")}
//                             </Button>
//                             <Button type="submit" variant="contained">
//                               {t("common.next")}
//                             </Button>
//                           </Box>
//                         </Box>
//                       </>
//                     )}
//                   </FieldArray>
//                 </Stack>
//               </Form>
//             </Paper>
//           </Container>
//         );
//       }}
//     </Formik>
//   );
// };

// export default ReturnedSection;


// import React, { useEffect, useRef } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
//   FormControl,
//   InputLabel,
//   Select,
// } from "@mui/material";
// import { Formik, Form, FieldArray, useFormikContext } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";

// const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

// const returnedValidationSchema = (t) =>
//   Yup.object({
//     returneds: Yup.array()
//       .of(
//         Yup.object({
//           returned_account_no: Yup.string()
//             .test(
//               "account-no-required",
//               t("returneds.validation.accountNoRequired"),
//               function (value) {
//                 // Get the current returned data to check if it's CASH
//                 const { returned_bank_name } = this.parent;
//                 // If returned_bank_name is "CASH", then returned_account_no is not required
//                 if (returned_bank_name === "CASH") {
//                   return true; // Validation passes for CASH
//                 }
//                 // Otherwise, returned_account_no is required
//                 return !!value && value.trim() !== "";
//               }
//             ),
//           returned_ifsc_code: Yup.string().required(t("returneds.validation.ifscCodeRequired")),
//           returned_bank_name: Yup.string().required(t("returneds.validation.bankNameRequired")),
//           returned_branch_name: Yup.string().required(t("returneds.validation.branchNameRequired")),
//           returned_mode_of_payment: Yup.string().required(t("returneds.validation.modeRequired")),
//           returned_scheme: Yup.string().required(t("returneds.validation.schemeRequired")),
//           returned_amt: Yup.number()
//             .typeError(t("returneds.validation.amountNumber"))
//             .required(t("returneds.validation.amountRequired")),
//           returned_proof: Yup.mixed()
//             .required(t("returneds.validation.proofRequired"))
//             .test(
//               "fileType",
//               t("returneds.validation.fileMustBePDF"),
//               (value) => !value || (value && value.type === "application/pdf")
//             )
//             .test(
//               "fileSize",
//               t("baseInfo.validation.fileSizeExceeded") || "File size must be less than 2MB",
//               (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
//             ),
//         })
//       )
//       .min(1, t("returneds.validation.atLeastOne")),
//   });

// const TotalWatcher = ({ onTotalChange }) => {
//   const { values } = useFormikContext();
//   useEffect(() => {
//     if (values.returneds) {
//       const total = values.returneds.reduce((sum, ret) => sum + (Number(ret.returned_amt) || 0), 0);
//       if (onTotalChange) onTotalChange(total);
//     }
//   }, [values.returneds, onTotalChange]);
//   return null;
// };

// const ReturnedSection = ({
//   returneds,
//   setReturneds,
//   activeTab,
//   setActiveTab,
//   onTotalChange,
//   schemeOptions,
//   investments,
// }) => {
//   const { t, i18n } = useTranslation();
//   const validationSchema = React.useMemo(() => returnedValidationSchema(t), [i18n.language]);

//   const formikHelpers = useRef(null);
//   useEffect(() => {
//     if (!formikHelpers.current) return;
//     const { errors, touched, setFieldTouched } = formikHelpers.current;
//     const handleLangChange = () => {
//       Object.keys(errors).forEach((field) => {
//         if (touched[field]) setFieldTouched(field);
//       });
//     };
//     i18n.on("languageChanged", handleLangChange);
//     return () => i18n.off("languageChanged", handleLangChange);
//   }, [i18n]);

//   const handleAccountChange = (formikHelpers, index, acc_no) => {
//     // Check if this is a CASH option (starts with "CASH_")
//     if (acc_no && acc_no.startsWith("CASH_")) {
//       // Extract scheme from CASH option (format: "CASH_FD")
//       const scheme = acc_no.replace("CASH_", "");
//       // Set empty account number for CASH transactions
//       formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, "CASH");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, "CASH");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, "CASH");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, scheme);
//       return;
//     }

//     // Regular investment account
//     const investment = investments.find((inv) => inv.inv_account_no === acc_no);
//     if (investment) {
//       formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, investment.inv_account_no);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, investment.inv_bank_name);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, investment.inv_ifsc_code);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, investment.inv_branch_name);
//       formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, investment.inv_scheme);
//     } else {
//       formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, "");
//       formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, "");
//     }
//   };

//   // Prepare investment options for the dropdown
//   const getInvestmentOptions = () => {
//     const options = [];
//     const schemeWithAccount = new Set(); // Track schemes that have account numbers
    
//     // First, add all investment accounts with their schemes
//     investments.forEach((inv) => {
//       if (inv.inv_account_no && inv.inv_scheme) {
//         const scheme = inv.inv_scheme;
//         const displayLabel = `${inv.inv_account_no} - ${scheme}`;
//         options.push({
//           value: inv.inv_account_no,
//           label: displayLabel,
//           scheme: scheme,
//           hasAccount: true
//         });
//         // Mark this scheme as having an account
//         schemeWithAccount.add(scheme);
//       }
//     });
    
//     // Add CASH options only for schemes that don't already have an account
//     schemeOptions.forEach((scheme) => {
//       if (scheme && !schemeWithAccount.has(scheme)) {
//         options.push({
//           value: `CASH_${scheme}`,
//           label: `- ${scheme}`,
//           scheme: scheme,
//           hasAccount: false
//         });
//       }
//     });
    
//     return options;
//   };

//   const investmentOptions = getInvestmentOptions();

//   return (
//     <Formik
//       initialValues={{ returneds }}
//       validationSchema={validationSchema}
//       enableReinitialize
//       onSubmit={(values) => {
//         setReturneds(values.returneds);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {(formik) => {
//         formikHelpers.current = formik;

//         const {
//           values,
//           errors,
//           touched,
//           handleChange,
//           handleBlur,
//           setFieldValue,
//           setFieldTouched,
//         } = formik;
//         const totalReturned = values.returneds.reduce(
//           (sum, ret) => sum + (Number(ret.returned_amt) || 0),
//           0
//         );
//         const selectFormControlSX = { minWidth: 200, maxWidth: "100%" };

//         return (
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Form noValidate>
//                 <Stack spacing={3}>
//                   <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
//                     {t("returneds.heading")}
//                   </Typography>

//                   <TotalWatcher onTotalChange={onTotalChange} />

//                   <FieldArray name="returneds">
//                     {({ remove, push }) => (
//                       <>
//                         {values.returneds.map((ret, i) => {
//                           const touchedRet = touched.returneds?.[i] || {};
//                           const errorsRet = errors.returneds?.[i] || {};

//                           // Check if current selection is CASH
//                           const isCash = ret.returned_bank_name === "CASH" || 
//                                          ret.returned_ifsc_code === "CASH" || 
//                                          ret.returned_branch_name === "CASH";

//                           return (
//                             <Box key={i} mb={2} p={2} sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
//                               <TwoFieldRow>
//                                 <FormControl fullWidth sx={selectFormControlSX} error={touchedRet.returned_account_no && Boolean(errorsRet.returned_account_no)}>
//                                   <InputLabel>{t("returneds.returnedAccountNo")}</InputLabel>
//                                   <Select
//                                     name={`returneds[${i}].returned_account_no`}
//                                     value={ret.returned_account_no || ""}
//                                     label={t("returneds.returnedAccountNo")}
//                                     onChange={(e) => {
//                                       const value = e.target.value;
//                                       setFieldValue(`returneds[${i}].returned_account_no`, value);
//                                       handleAccountChange(formikHelpers.current, i, value);
//                                     }}
//                                     onBlur={handleBlur}
//                                   >
//                                     <MenuItem value="">
//                                       <em>{t("common.select")}</em>
//                                     </MenuItem>
//                                     {investmentOptions.map((option) => (
//                                       <MenuItem key={option.value} value={option.value}>
//                                         {option.label}
//                                       </MenuItem>
//                                     ))}
//                                   </Select>
//                                   {touchedRet.returned_account_no && errorsRet.returned_account_no && (
//                                     <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                       {errorsRet.returned_account_no}
//                                     </Typography>
//                                   )}
//                                 </FormControl>

//                                 <TextField
//                                   label={t("returneds.bankName")}
//                                   name={`returneds[${i}].returned_bank_name`}
//                                   value={ret.returned_bank_name}
//                                   InputProps={{ readOnly: true }}
//                                   fullWidth
//                                   sx={{ ml: 2 }}
//                                 />
//                               </TwoFieldRow>

//                               <TwoFieldRow>
//                                 <TextField
//                                   label={t("returneds.ifscCode")}
//                                   name={`returneds[${i}].returned_ifsc_code`}
//                                   value={ret.returned_ifsc_code}
//                                   InputProps={{ readOnly: true }}
//                                   fullWidth
//                                   error={touchedRet.returned_ifsc_code && Boolean(errorsRet.returned_ifsc_code)}
//                                   helperText={touchedRet.returned_ifsc_code && errorsRet.returned_ifsc_code}
//                                 />
//                                 <TextField
//                                   label={t("returneds.branchName")}
//                                   name={`returneds[${i}].returned_branch_name`}
//                                   value={ret.returned_branch_name}
//                                   InputProps={{ readOnly: true }}
//                                   fullWidth
//                                   error={touchedRet.returned_branch_name && Boolean(errorsRet.returned_branch_name)}
//                                   helperText={touchedRet.returned_branch_name && errorsRet.returned_branch_name}
//                                 />
//                               </TwoFieldRow>

//                               {/* Scheme as read-only TextField */}
//                               <TextField
//                                 label={t("returneds.scheme")}
//                                 name={`returneds[${i}].returned_scheme`}
//                                 value={ret.returned_scheme || ""}
//                                 InputProps={{ readOnly: true }}
//                                 fullWidth
//                                 error={touchedRet.returned_scheme && Boolean(errorsRet.returned_scheme)}
//                                 helperText={touchedRet.returned_scheme && errorsRet.returned_scheme}
//                                 sx={{ mb: 2 }}
//                               />

//                               <TwoFieldRow>
//                                 <FormControl fullWidth sx={selectFormControlSX} error={touchedRet.returned_mode_of_payment && Boolean(errorsRet.returned_mode_of_payment)}>
//                                   <InputLabel>{t("returneds.modeOfPayment")}</InputLabel>
//                                   <Select
//                                     name={`returneds[${i}].returned_mode_of_payment`}
//                                     value={ret.returned_mode_of_payment}
//                                     label={t("returneds.modeOfPayment")}
//                                     onChange={handleChange}
//                                     onBlur={handleBlur}
//                                   >
//                                     <MenuItem value="">{t("returneds.selectMode")}</MenuItem>
//                                     <MenuItem value="NEFT">NEFT</MenuItem>
//                                     <MenuItem value="Cash">Cash</MenuItem>
//                                     <MenuItem value="Cheque">Cheque</MenuItem>
//                                     <MenuItem value="RTGS">RTGS</MenuItem>
//                                     <MenuItem value="UPI">UPI</MenuItem>
//                                   </Select>
//                                   {touchedRet.returned_mode_of_payment && errorsRet.returned_mode_of_payment && (
//                                     <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                       {errorsRet.returned_mode_of_payment}
//                                     </Typography>
//                                   )}
//                                 </FormControl>

//                                 <TextField
//                                   label={t("returneds.amount")}
//                                   name={`returneds[${i}].returned_amt`}
//                                   value={ret.returned_amt}
//                                   onChange={handleChange}
//                                   onBlur={handleBlur}
//                                   fullWidth
//                                   error={touchedRet.returned_amt && Boolean(errorsRet.returned_amt)}
//                                   helperText={touchedRet.returned_amt && errorsRet.returned_amt}
//                                 />
//                               </TwoFieldRow>

//                               <Box sx={{ mb: 1 }}>
//                                 <UploadWithLabel
//                                   label={`${t("returneds.uploadStatement")}`}
//                                   name={`returneds[${i}].returned_proof`}
//                                   onChange={(e) => {
//                                     const file = e.currentTarget.files[0];
//                                     if (file) {
//                                       setFieldValue(`returneds[${i}].returned_proof`, file);
//                                       setFieldTouched(`returneds[${i}].returned_proof`, true);
//                                     }
//                                   }}
//                                   accept=".pdf,application/pdf"
//                                   file={ret.returned_proof}
//                                   error={touchedRet.returned_proof && Boolean(errorsRet.returned_proof)}
//                                   helperText={touchedRet.returned_proof && errorsRet.returned_proof}
//                                 />
//                                 {touchedRet.returned_proof && errorsRet.returned_proof && (
//                                   <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                     {errorsRet.returned_proof}
//                                   </Typography>
//                                 )}
//                               </Box>

//                               <Button
//                                 variant="outlined"
//                                 color="error"
//                                 onClick={() => values.returneds.length > 1 && setFieldValue("returneds", values.returneds.filter((_, idx) => idx !== i))}
//                                 sx={{ mt: 1 }}
//                               >
//                                 {t("common.remove")}
//                               </Button>
//                             </Box>
//                           );
//                         })}

//                         <Button
//                           variant="contained"
//                           sx={{ mt: 2 }}
//                           onClick={() =>
//                             setFieldValue("returneds", [
//                               ...values.returneds,
//                               {
//                                 returned_account_no: "",
//                                 returned_ifsc_code: "",
//                                 returned_bank_name: "",
//                                 returned_branch_name: "",
//                                 returned_mode_of_payment: "",
//                                 returned_scheme: "",
//                                 returned_amt: "", 
//                                 returned_proof: null,
//                               },
//                             ])
//                           }
//                         >
//                           {t("returneds.addReturned")}
//                         </Button>

//                         <Box sx={{ mt: 4, p: 2, border: "1px solid #999", borderRadius: 2, backgroundColor: "#f9f9f9" }}>
//                           <Typography variant="h6" gutterBottom>
//                             {t("returneds.summary")}
//                           </Typography>
//                           <TextField
//                             label={t("returneds.totalReturnedAmount")}
//                             value={totalReturned.toFixed(2)}
//                             InputProps={{ readOnly: true }}
//                             fullWidth
//                           />
//                         </Box>

//                         <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//                           <Button variant="outlined" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
//                             {t("common.back")}
//                           </Button>
//                           <Box sx={{ display: "flex", gap: 2 }}>
//                             <Button variant="outlined" color="secondary" onClick={() => setActiveTab(activeTab + 1)}>
//                               {t("common.skip")}
//                             </Button>
//                             <Button 
//                               type="submit" 
//                               variant="contained"
//                               sx={{
//                                 "&.Mui-disabled": {
//                                   backgroundColor: "rgba(25, 118, 210, 0.6)",
//                                   color: "rgba(255, 255, 255, 0.9)",
//                                   cursor: "not-allowed",
//                                 },
//                               }}
//                             >
//                               {t("common.next")}
//                             </Button>
//                           </Box>
//                         </Box>
//                       </>
//                     )}
//                   </FieldArray>
//                 </Stack>
//               </Form>
//             </Paper>
//           </Container>
//         );
//       }}
//     </Formik>
//   );
// };

// export default ReturnedSection;

import React, { useEffect, useRef } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  MenuItem,
  Container,
  Paper,
  Stack,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { Formik, Form, FieldArray, useFormikContext } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import TwoFieldRow from "./twoFieldsRow";
import UploadWithLabel from "./uploadWithLable";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

const returnedValidationSchema = (t) =>
  Yup.object({
    returneds: Yup.array()
      .of(
        Yup.object({
          returned_account_no: Yup.string()
            .test(
              "account-no-required",
              t("returneds.validation.accountNoRequired"),
              function (value) {
                const { returned_bank_name } = this.parent;
                if (returned_bank_name === "CASH") {
                  return true;
                }
                return !!value && value.trim() !== "";
              }
            ),
          returned_ifsc_code: Yup.string().required(t("returneds.validation.ifscCodeRequired")),
          returned_bank_name: Yup.string().required(t("returneds.validation.bankNameRequired")),
          returned_branch_name: Yup.string().required(t("returneds.validation.branchNameRequired")),
          returned_mode_of_payment: Yup.string().required(t("returneds.validation.modeRequired")),
          returned_scheme: Yup.string().required(t("returneds.validation.schemeRequired")),
          returned_amt: Yup.number()
            .typeError(t("returneds.validation.amountNumber"))
            .required(t("returneds.validation.amountRequired")),
          returned_proof: Yup.mixed()
            .required(t("returneds.validation.proofRequired"))
            .test(
              "fileType",
              t("returneds.validation.fileMustBePDF"),
              (value) => !value || (value && value.type === "application/pdf")
            )
            .test(
              "fileSize",
              t("baseInfo.validation.fileSizeExceeded") || "File size must be less than 2MB",
              (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
            ),
        })
      )
      .min(1, t("returneds.validation.atLeastOne")),
  });

const TotalWatcher = ({ onTotalChange }) => {
  const { values } = useFormikContext();
  useEffect(() => {
    if (values.returneds) {
      const total = values.returneds.reduce((sum, ret) => sum + (Number(ret.returned_amt) || 0), 0);
      if (onTotalChange) onTotalChange(total);
    }
  }, [values.returneds, onTotalChange]);
  return null;
};

const ReturnedSection = ({
  returneds,
  setReturneds,
  activeTab,
  setActiveTab,
  onTotalChange,
  schemeOptions,
  investments,
}) => {
  const { t, i18n } = useTranslation();
  const validationSchema = React.useMemo(() => returnedValidationSchema(t), [i18n.language]);

  const formikHelpers = useRef(null);
  useEffect(() => {
    if (!formikHelpers.current) return;
    const { errors, touched, setFieldTouched } = formikHelpers.current;
    const handleLangChange = () => {
      Object.keys(errors).forEach((field) => {
        if (touched[field]) setFieldTouched(field);
      });
    };
    i18n.on("languageChanged", handleLangChange);
    return () => i18n.off("languageChanged", handleLangChange);
  }, [i18n]);

  const handleAccountChange = (formikHelpers, index, acc_no) => {
    if (acc_no && acc_no.startsWith("CASH_")) {
      const scheme = acc_no.replace("CASH_", "");
      formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, "");
      formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, "CASH");
      formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, "CASH");
      formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, "CASH");
      formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, scheme);
      return;
    }

    const investment = investments.find((inv) => inv.inv_account_no === acc_no);
    if (investment) {
      formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, investment.inv_account_no);
      formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, investment.inv_bank_name);
      formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, investment.inv_ifsc_code);
      formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, investment.inv_branch_name);
      formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, investment.inv_scheme);
    } else {
      formikHelpers.setFieldValue(`returneds[${index}].returned_bank_name`, "");
      formikHelpers.setFieldValue(`returneds[${index}].returned_ifsc_code`, "");
      formikHelpers.setFieldValue(`returneds[${index}].returned_branch_name`, "");
      formikHelpers.setFieldValue(`returneds[${index}].returned_scheme`, "");
      formikHelpers.setFieldValue(`returneds[${index}].returned_account_no`, "");
    }
  };

  const getInvestmentOptions = () => {
    const options = [];
    const schemeWithAccount = new Set();
    
    investments.forEach((inv) => {
      if (inv.inv_account_no && inv.inv_scheme) {
        const scheme = inv.inv_scheme;
        const displayLabel = `${inv.inv_account_no} - ${scheme}`;
        options.push({
          value: inv.inv_account_no,
          label: displayLabel,
          scheme: scheme,
          hasAccount: true
        });
        schemeWithAccount.add(scheme);
      }
    });
    
    schemeOptions.forEach((scheme) => {
      if (scheme && !schemeWithAccount.has(scheme)) {
        options.push({
          value: `CASH_${scheme}`,
          label: `- ${scheme}`,
          scheme: scheme,
          hasAccount: false
        });
      }
    });
    
    return options;
  };

  const investmentOptions = getInvestmentOptions();

  // Build a map of scheme -> total allowed investment amount from the investments prop
  const getSchemeInvestmentTotals = () => {
    const schemeTotals = {};
    investments.forEach((inv) => {
      if (inv.inv_scheme) {
        schemeTotals[inv.inv_scheme] =
          (schemeTotals[inv.inv_scheme] || 0) + (Number(inv.inv_amt) || 0);
      }
    });
    return schemeTotals;
  };

  return (
    <Formik
      initialValues={{ returneds }}
      validationSchema={validationSchema}
      enableReinitialize
      validate={(values) => {
        const errors = {};

        // Per-scheme: returned total must NOT exceed that scheme's invested total
        const schemeInvestmentTotals = getSchemeInvestmentTotals();

        // Sum up returned amounts per scheme
        const schemeReturnedTotals = {};
        values.returneds.forEach((ret) => {
          const scheme = ret.returned_scheme;
          if (scheme) {
            schemeReturnedTotals[scheme] =
              (schemeReturnedTotals[scheme] || 0) + (Number(ret.returned_amt) || 0);
          }
        });

        // Check each scheme that has a known investment total
        const schemeErrors = [];
        Object.entries(schemeReturnedTotals).forEach(([scheme, returned]) => {
          const allowed = schemeInvestmentTotals[scheme];
          if (allowed !== undefined && Number(returned.toFixed(2)) > Number(allowed.toFixed(2))) {
            schemeErrors.push(
              t("returneds.schemeExceedsInvestmentMessage", {
                scheme,
                returned: returned.toFixed(2),
                allowed: allowed.toFixed(2),
              })
            );
          }
        });

        if (schemeErrors.length > 0) {
          errors._schemeExceeds = schemeErrors.join(" | ");
        }

        return errors;
      }}
      onSubmit={(values) => {
        setReturneds(values.returneds);
        setActiveTab(activeTab + 1);
      }}
    >
      {(formik) => {
        formikHelpers.current = formik;

        const {
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          setFieldTouched,
        } = formik;
        const totalReturned = values.returneds.reduce(
          (sum, ret) => sum + (Number(ret.returned_amt) || 0),
          0
        );
        const selectFormControlSX = { minWidth: 200, maxWidth: "100%" };

        return (
          <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
            <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
              <Form noValidate>
                <Stack spacing={3}>
                  <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
                    {t("returneds.heading")}
                  </Typography>

                  <TotalWatcher onTotalChange={onTotalChange} />

                  <FieldArray name="returneds">
                    {({ remove, push }) => (
                      <>
                        {values.returneds.map((ret, i) => {
                          const touchedRet = touched.returneds?.[i] || {};
                          const errorsRet = errors.returneds?.[i] || {};

                          const isCash = ret.returned_bank_name === "CASH" || 
                                         ret.returned_ifsc_code === "CASH" || 
                                         ret.returned_branch_name === "CASH";

                          return (
                            <Box key={i} mb={2} p={2} sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
                              <TwoFieldRow>
                                <FormControl fullWidth sx={selectFormControlSX} error={touchedRet.returned_account_no && Boolean(errorsRet.returned_account_no)}>
                                  <InputLabel>{t("returneds.returnedAccountNo")}</InputLabel>
                                  <Select
                                    name={`returneds[${i}].returned_account_no`}
                                    value={ret.returned_account_no || ""}
                                    label={t("returneds.returnedAccountNo")}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setFieldValue(`returneds[${i}].returned_account_no`, value);
                                      handleAccountChange(formikHelpers.current, i, value);
                                    }}
                                    onBlur={handleBlur}
                                  >
                                    <MenuItem value="">
                                      <em>{t("common.select")}</em>
                                    </MenuItem>
                                    {investmentOptions.map((option) => (
                                      <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {touchedRet.returned_account_no && errorsRet.returned_account_no && (
                                    <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                                      {errorsRet.returned_account_no}
                                    </Typography>
                                  )}
                                </FormControl>

                                <TextField
                                  label={t("returneds.bankName")}
                                  name={`returneds[${i}].returned_bank_name`}
                                  value={ret.returned_bank_name}
                                  InputProps={{ readOnly: true }}
                                  fullWidth
                                  sx={{ ml: 2 }}
                                />
                              </TwoFieldRow>

                              <TwoFieldRow>
                                <TextField
                                  label={t("returneds.ifscCode")}
                                  name={`returneds[${i}].returned_ifsc_code`}
                                  value={ret.returned_ifsc_code}
                                  InputProps={{ readOnly: true }}
                                  fullWidth
                                  error={touchedRet.returned_ifsc_code && Boolean(errorsRet.returned_ifsc_code)}
                                  helperText={touchedRet.returned_ifsc_code && errorsRet.returned_ifsc_code}
                                />
                                <TextField
                                  label={t("returneds.branchName")}
                                  name={`returneds[${i}].returned_branch_name`}
                                  value={ret.returned_branch_name}
                                  InputProps={{ readOnly: true }}
                                  fullWidth
                                  error={touchedRet.returned_branch_name && Boolean(errorsRet.returned_branch_name)}
                                  helperText={touchedRet.returned_branch_name && errorsRet.returned_branch_name}
                                />
                              </TwoFieldRow>

                              <TextField
                                label={t("returneds.scheme")}
                                name={`returneds[${i}].returned_scheme`}
                                value={ret.returned_scheme || ""}
                                InputProps={{ readOnly: true }}
                                fullWidth
                                error={touchedRet.returned_scheme && Boolean(errorsRet.returned_scheme)}
                                helperText={touchedRet.returned_scheme && errorsRet.returned_scheme}
                                sx={{ mb: 2 }}
                              />

                              <TwoFieldRow>
                                <FormControl fullWidth sx={selectFormControlSX} error={touchedRet.returned_mode_of_payment && Boolean(errorsRet.returned_mode_of_payment)}>
                                  <InputLabel>{t("returneds.modeOfPayment")}</InputLabel>
                                  <Select
                                    name={`returneds[${i}].returned_mode_of_payment`}
                                    value={ret.returned_mode_of_payment}
                                    label={t("returneds.modeOfPayment")}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  >
                                    <MenuItem value="">{t("returneds.selectMode")}</MenuItem>
                                    <MenuItem value="NEFT">NEFT</MenuItem>
                                    <MenuItem value="Cash">Cash</MenuItem>
                                    <MenuItem value="Cheque">Cheque</MenuItem>
                                    <MenuItem value="RTGS">RTGS</MenuItem>
                                    <MenuItem value="UPI">UPI</MenuItem>
                                  </Select>
                                  {touchedRet.returned_mode_of_payment && errorsRet.returned_mode_of_payment && (
                                    <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                                      {errorsRet.returned_mode_of_payment}
                                    </Typography>
                                  )}
                                </FormControl>

                                <TextField
                                  label={t("returneds.amount")}
                                  name={`returneds[${i}].returned_amt`}
                                  value={ret.returned_amt}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  fullWidth
                                  error={touchedRet.returned_amt && Boolean(errorsRet.returned_amt)}
                                  helperText={touchedRet.returned_amt && errorsRet.returned_amt}
                                />
                              </TwoFieldRow>

                              <Box sx={{ mb: 1 }}>
                                <UploadWithLabel
                                  label={`${t("returneds.uploadStatement")}`}
                                  name={`returneds[${i}].returned_proof`}
                                  onChange={(e) => {
                                    const file = e.currentTarget.files[0];
                                    if (file) {
                                      setFieldValue(`returneds[${i}].returned_proof`, file);
                                      setFieldTouched(`returneds[${i}].returned_proof`, true);
                                    }
                                  }}
                                  accept=".pdf,application/pdf"
                                  file={ret.returned_proof}
                                  error={touchedRet.returned_proof && Boolean(errorsRet.returned_proof)}
                                  helperText={touchedRet.returned_proof && errorsRet.returned_proof}
                                />
                                {touchedRet.returned_proof && errorsRet.returned_proof && (
                                  <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                                    {errorsRet.returned_proof}
                                  </Typography>
                                )}
                              </Box>

                              <Button
                                variant="outlined"
                                color="error"
                                onClick={() => values.returneds.length > 1 && setFieldValue("returneds", values.returneds.filter((_, idx) => idx !== i))}
                                sx={{ mt: 1 }}
                              >
                                {t("common.remove")}
                              </Button>
                            </Box>
                          );
                        })}

                        <Button
                          variant="contained"
                          sx={{ mt: 2 }}
                          onClick={() =>
                            setFieldValue("returneds", [
                              ...values.returneds,
                              {
                                returned_account_no: "",
                                returned_ifsc_code: "",
                                returned_bank_name: "",
                                returned_branch_name: "",
                                returned_mode_of_payment: "",
                                returned_scheme: "",
                                returned_amt: "", 
                                returned_proof: null,
                              },
                            ])
                          }
                        >
                          {t("returneds.addReturned")}
                        </Button>

                        <Box sx={{ mt: 4, p: 2, border: "1px solid #999", borderRadius: 2, backgroundColor: "#f9f9f9" }}>
                          <Typography variant="h6" gutterBottom>
                            {t("returneds.summary")}
                          </Typography>
                          <TextField
                            label={t("returneds.totalReturnedAmount")}
                            value={totalReturned.toFixed(2)}
                            InputProps={{ readOnly: true }}
                            fullWidth
                            error={Boolean(errors._schemeExceeds)}
                            helperText={
                              errors._schemeExceeds && (
                                <span>
                                  {errors._schemeExceeds.split(" | ").map((msg, i) => (
                                    <span key={i} style={{ display: "block" }}>
                                      {msg}
                                    </span>
                                  ))}
                                </span>
                              )
                            }
                          />
                        </Box>

                        <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Button variant="outlined" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
                            {t("common.back")}
                          </Button>
                          <Box sx={{ display: "flex", gap: 2 }}>
                            <Button variant="outlined" color="secondary" onClick={() => setActiveTab(activeTab + 1)}>
                              {t("common.skip")}
                            </Button>
                            <Button 
                              type="submit" 
                              variant="contained"
                              sx={{
                                "&.Mui-disabled": {
                                  backgroundColor: "rgba(25, 118, 210, 0.6)",
                                  color: "rgba(255, 255, 255, 0.9)",
                                  cursor: "not-allowed",
                                },
                              }}
                            >
                              {t("common.next")}
                            </Button>
                          </Box>
                        </Box>
                      </>
                    )}
                  </FieldArray>
                </Stack>
              </Form>
            </Paper>
          </Container>
        );
      }}
    </Formik>
  );
};

export default ReturnedSection;
